import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'First Fellow Partners';
const DEFAULT_OG_IMAGE = '/og-image.png';

/**
 * SEOHead — sets per-page <title>, <meta description>, and Open Graph tags.
 * Uses react-helmet-async which updates <head> during the React render cycle.
 */
export const SEOHead = ({ title, description, path = '' }) => {
  const url = `https://www.firstfellow.com${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="title" content={title} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:image" content={DEFAULT_OG_IMAGE} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={DEFAULT_OG_IMAGE} />

      {/* Canonical */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};
